/**
 * Reusable decorative background shapes.
 * variant="dark"  — primary red glows + border square (for ink/image backgrounds)
 * variant="light" — softer muted glows (for white/ghost-white backgrounds)
 */
export default function SectionShapes({ variant = "dark" }) {
  const isDark = variant === "dark";

  return (
    <>
      {/* Left blurred glow */}
      <div className={`absolute top-1/2 -translate-y-1/2 left-8 w-72 h-72 rounded-full blur-3xl pointer-events-none ${isDark ? "bg-primary/10" : "bg-primary/5"}`} />
      {/* Right blurred glow */}
      <div className={`absolute top-1/2 -translate-y-1/2 right-8 w-72 h-72 rounded-full blur-3xl pointer-events-none ${isDark ? "bg-primary/5" : "bg-primary/3"}`} />
      {/* Top-right bordered square */}
      <div className={`absolute top-30 right-0 w-24 h-24 border-2 rotate-10 rounded-2xl pointer-events-none ${isDark ? "border-primary/20" : "border-primary/15"}`} />
      {/* Bottom-left filled square */}
      <div className={`absolute -bottom-5 left-2 w-16 h-16 rounded-xl -rotate-10 pointer-events-none ${isDark ? "bg-primary/10" : "bg-primary/5"}`} />
    </>
  );
}
